import React from 'react';
import { useParams } from 'react-router-dom';
import { DATE_FORMAT_URL } from '../../../../data/constants/datetime';
import RelativeRedirect from '../../../elements/RelativeRedirect';
import { useDefaultScheduleTab } from './defaultScheduleTabTools';
import { useDefaultScheduleDate } from './useDefaultScheduleDate';

function EventScheduleDefaultRoute(props) {
    const {} = props,
        { eventId } = useParams(),
        defaultDate = useDefaultScheduleDate(eventId),
        defaultTab = useDefaultScheduleTab(eventId);

    if (!defaultDate) return <RelativeRedirect to=".." />;

    return <RelativeRedirect to={`${defaultDate.format(DATE_FORMAT_URL)}/${defaultTab}`} />;
}

export default EventScheduleDefaultRoute;
